import { c as _c } from "react/compiler-runtime";
import { Media } from '@/app/[locale]/(worlds)/[roomId]/components/TrailerCarouselSlide';
import { RefObject, useCallback } from 'react';

/**
 * Auto scroll thumbnail to visible area
 * @param container - parent container
 * @param thumbnailRef - thumbnail elements
 * @returns scrollToThumbnail function
 */
function useThumbnailScroll(container, thumbnailRef) {
  const $ = _c(3);
  let t0;
  if ($[0] !== container || $[1] !== thumbnailRef) {
    t0 = (index, fullWidth, mediaList, onSelect) => {
      if (!container || !thumbnailRef.current[index]) {
        return;
      }
      onSelect(index);
      const thumbnail = thumbnailRef.current[index];
      const scrollMax = container.scrollWidth - container.clientWidth;
      const containerRect = container.getBoundingClientRect();
      const thumbnailRect = thumbnail.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const containerRight = containerLeft + container.clientWidth;
      const thumbnailLeft = thumbnailRect.left;
      const thumbnailRight = thumbnailRect.right;
      const isFullyVisible = thumbnailLeft >= containerLeft && thumbnailRight <= containerRight;
      if (isFullyVisible) {
        return;
      }
      let scrollTarget;
      const indexOffsetLeft = thumbnail.offsetLeft;
      const indexOffsetRight = indexOffsetLeft + fullWidth;
      const containerWidth = container.clientWidth;
      if (index === 0) {
        scrollTarget = 0;
      } else {
        if (index === mediaList.length - 1) {
          scrollTarget = scrollMax;
        } else {
          if (thumbnailRight > containerRight) {
            const remainingRight = container.scrollWidth - indexOffsetLeft;
            if (remainingRight <= containerWidth) {
              scrollTarget = scrollMax;
            } else {
              scrollTarget = Math.max(indexOffsetLeft - fullWidth + fullWidth * 0.6, 0);
            }
          } else {
            if (thumbnailLeft < containerLeft) {
              const remainingLeft = indexOffsetRight;
              if (remainingLeft <= containerWidth) {
                scrollTarget = 0;
              } else {
                scrollTarget = Math.max(indexOffsetRight - (containerWidth - fullWidth * 0.8), 0);
              }
            } else {
              return;
            }
          }
        }
      }
      container.scrollTo({
        left: scrollTarget,
        behavior: "smooth"
      });
    };
    $[0] = container;
    $[1] = thumbnailRef;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export default useThumbnailScroll;